import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

export const defaultData: BaseBlock = {
  id: "form-short-answer-block",
  type: "FormShortAnswerBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: "Short answer",
    },
    placeholder: {
      prop: "other",
      type: "string",
      value: "",
    },
    required: {
      prop: "other",
      type: "boolean",
      value: false,
    },
  },
};
